import { Company, CompanyType } from './company'
import { IdentifySchema } from '@tino-frontend/analytics'
import { StatusType } from './store'

export type UserRoles = 'merchant' | 'supplier' | 'salesperson'

export interface User {
  companies: Company[]
  currentCompany: Company
  display_name: string
  email: string
  id: string
  is_admin: boolean
  imageUrl?: string
  document_number: string
}

export interface MeResponse {
  companies: Company[]
  display_name: string
  email: string
  id: string
  is_admin: boolean
  document_number: string
}

export interface NaturalPersonData {
  document_number: string
  document_type: string
  name: string
}

export interface UserPayload {
  mobile_phone: string
  name?: string
  document_number?: string
}

export interface UserContact {
  id: string
  name: string
  user_id: string
  phone: string
  email: string
  company_ids: string[]
  created_at: string
  updated_at: string
  dont_want_notification: boolean
}

export interface UserPreApprovedResponse {
  registered: boolean
  registered_in_auth_service: boolean
}

export interface UserTargetData {
  isAnonymous?: boolean
  isAdmin: boolean
  email?: string
  authId?: string
  userId?: string
  type: CompanyType | 'buyer_seller' | undefined
}

export type CreditLimitStatus =
  | 'undefined'
  | 'available'
  | 'used'
  | 'blocked'
  | 'rejected'

export enum CreditLimitStatusEnum {
  Undefined = 'undefined',
  Available = 'available',
  Used = 'used',
  Blocked = 'blocked',
  Rejected = 'rejected',
}

export interface CreditLimitResponse {
  available_limit_cents: number
  used_limit_cents: number
  displayed_limit_cents: number
  status: CreditLimitStatusEnum
}

export type UserIdentify = Partial<Omit<IdentifySchema, 'email'>> & {
  id: string
  companyId?: string
  authId?: string
  role?: string
  admin?: boolean
  companyType?: CompanyType
  email: string | null
}

export enum CheckUnicoReason {
  USER_VALIDATION = 'USER_VALIDATION',
  OWNER_BIOMETRY = 'OWNER_BIOMETRY',
}

export interface CheckUnicoPayload {
  image_data: string
  image_encrypted: string
}

export interface CheckResponse {
  data?: CheckUnicoResponse
  status: StatusType
}

export interface PollingResponse {
  result: CheckUnicoResultResponseResult
  status: StatusType
  error?: string
}

export interface CheckUnicoResponse {
  workflow_id: string
  run_id: string
}

export enum CheckUnicoResultResponseResult {
  NOT_PROCESSED = 'NOT_PROCESSED',
  APPROVED = 'APPROVED',
  REJECT = 'REJECT',
  FAILED = 'FAILED',
  LIVENESS_REPROVED = 'LIVENESS_REPROVED',
}
export interface CheckUnicoResultResponse {
  result: CheckUnicoResultResponseResult
}

export enum CameraStatus {
  INITIAL = 'initial', // initial state
  PREPARING = 'preparing', // waiting Unico magic
  OPENED = 'opened', // camera opened
  CLOSED = 'closed', // camera closed
  ERROR = 'error', // camera has some type of error
}
